var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5370_25620",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5370_25620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39037 7.75781L8.54453 6.91198C8.63203 6.45504 8.50078 6.02726 8.15078 5.62865C7.80078 5.23004 7.3487 5.07448 6.79453 5.16198L5.9487 4.31615C6.11398 4.23837 6.28168 4.18004 6.45182 4.14115C6.62196 4.10226 6.80425 4.08281 6.9987 4.08281C7.72787 4.08281 8.34766 4.33802 8.85807 4.84844C9.36849 5.35885 9.6237 5.97865 9.6237 6.70781C9.6237 6.90226 9.60425 7.08455 9.56537 7.25469C9.52648 7.42483 9.46814 7.59254 9.39037 7.75781ZM11.257 9.59531L10.4112 8.77865C10.7806 8.4967 11.1088 8.18802 11.3956 7.85261C11.6824 7.51719 11.9279 7.13559 12.132 6.70781C11.6459 5.72587 10.9484 4.94566 10.0393 4.36719C9.1303 3.78872 8.11675 3.49948 6.9987 3.49948C6.71675 3.49948 6.43967 3.51892 6.16745 3.55781C5.89523 3.5967 5.62786 3.65504 5.36537 3.73281L4.4612 2.82865C4.85981 2.66337 5.26814 2.53941 5.6862 2.45677C6.10425 2.37413 6.54175 2.33281 6.9987 2.33281C8.46675 2.33281 9.77439 2.73872 10.9216 3.55052C12.0688 4.36233 12.9001 5.41476 13.4154 6.70781C13.1918 7.28142 12.8977 7.81372 12.5331 8.30469C12.1685 8.79566 11.7431 9.22587 11.257 9.59531ZM11.5487 13.1828L9.0987 10.762C8.75842 10.8689 8.41571 10.9491 8.07057 11.0026C7.72543 11.0561 7.36814 11.0828 6.9987 11.0828C5.53064 11.0828 4.223 10.6769 3.07578 9.86511C1.92856 9.0533 1.09731 8.00087 0.582031 6.70781C0.786198 6.19254 1.04384 5.71372 1.35495 5.27135C1.66606 4.82899 2.02092 4.43281 2.41953 4.08281L0.815365 2.44948L1.63203 1.63281L12.3654 12.3661L11.5487 13.1828ZM3.2362 4.89948C2.95425 5.15226 2.69661 5.42934 2.46328 5.73073C2.22995 6.03212 2.03064 6.35781 1.86536 6.70781C2.35148 7.68976 3.04905 8.46997 3.95807 9.04844C4.8671 9.62691 5.88064 9.91615 6.9987 9.91615C7.19314 9.91615 7.38273 9.90399 7.56745 9.87969C7.75217 9.85538 7.94175 9.82865 8.1362 9.79948L7.6112 9.24531C7.50425 9.27448 7.40217 9.29636 7.30495 9.31094C7.20773 9.32552 7.10564 9.33281 6.9987 9.33281C6.26953 9.33281 5.64974 9.07761 5.13932 8.56719C4.62891 8.05677 4.3737 7.43698 4.3737 6.70781C4.3737 6.60087 4.38099 6.49879 4.39557 6.40156C4.41016 6.30434 4.43203 6.20226 4.4612 6.09531L3.2362 4.89948Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisibilityOff);
export default __webpack_public_path__ + "static/media/EyeVisibilityOff.bad3b9dee86893531a9418821a0ff370.svg";
export { ForwardRef as ReactComponent };